<template>
  <div class="must" :id="el.id">
    <form v-if="customMode" v-drag @click="onFocus" class="p-1 drag-item" :style="{
      transformOrigin: 'top left',
      border: 'none',
      '--current-outline': `${color}`,
      transform: `scale(${el.scale})`,
      boderColor: `${color}`,
      position: 'absolute',
      width: `${el.width}px`,
      top: `${el.top}px`,
      left: `${el.left}px`,
    }" @v-drag-end="onDragEnd">
    <div 
    v-if="el.required"
    style="color: red;height: 26px;font-size: 22px;position: absolute;left: -12px;top: 0;"
     >*</div>
      <input :placeholder="el.name" class="cs-input" type="text"
        :style="{ outlineColor: `${color}`, color: `${color}`, fontSize: `${el.size}`, fontFamily: `'${el.font}', text-align: ${el.font === 'arialunicode' ? 'right' : 'left'} ; sans-serif`, backgroundColor: 'white' }" />
      <button @click.prevent="onRemove" class="cursor p-close">X</button>
    </form>
    <template v-else>
      <div v-if="checkdatevalue"
        :style="`width: ${el.width}; position: absolute; text-align: ${el.font === 'arialunicode' ? 'right' : 'left'};  transform: scale(${el.scale});font-size:${el.size};transform-origin: top left; top: calc(${ el.top}px + 20.5px - ${el.size}px); left:${el.left}; z-index: 1`">

        <span :style="{ fontFamily: `'${el.font}', sans-serif`, color: `${color}`, fontSize: `${el.size}` }">{{ datenow
        }}</span>
      </div>
      <form v-else :style="{
          zIndex: 3,
          transformOrigin: 'top left',
          border: 'none',
          transform: `scale(${el.scale})`,
          boderColor: `${color}`,
          position: 'absolute',
          top: `${el.top}px`,
          width: `${el.width}px`,
          textAlign: el.font === 'arialunicode' ? 'right' : 'left',
          left: `${el.left}px`,
        }">

        <v-date-picker :color="color" v-model="el.value" @input="inputted" :mode="dateFormat[value[1]][1]"
          :is24hr="dateFormat[value[1]][2]" :isDark="$store.state.theme.darkMode" :masks="{
            modelValue: dateFormat[value[1]][0],
          }" :isRange="false" :popover="{ visibility: 'click', placement: 'bottom-start' }">
          <template v-slot="{ inputValue, inputEvents }">
            <div class="date-picker-input">
              <div class="input-group"
                :style="{ border: `2px solid ${color} !important`, '--current-outline': `${color}` }">
                <input :value="inputValue ? inputValue : ''" :placeholder="el.name" v-on="inputEvents"
                  :style="{ outlineColor: `${color}`, padding: '0px  0 0 6px !important', color: `${color}`, fontSize: `${el.size} !important`, fontFamily: `'${el.font}', sans-serif`, backgroundColor: 'white' }"
                  class="form-control cs-input" />
              </div>
            </div>
          </template>
        </v-date-picker>
      </form>
    </template>
  </div>
</template>

<script>
import mixins from "./mixins";
import moment from "moment";

export default {
  mixins: [mixins],
  data() {
    return {
      value: this.el.value,
      dateFormat: {
        'date': ["", 'date', null],
        'datetime12': ["h:mm A", "datetime", false],
        'datetime24': ["HH:mm", "datetime", true],
        'time12': ["h:mm A", "time", false],
        'time24': ["HH:mm", "time", true],
      },
    };
  },
  methods: {
    inputted(val) {
      const [_, format] = this.value
      this.el.value = moment.utc(val).format(this.dateFormat[format][0]);
    },
  },
  computed: {
    checkdatevalue() {
      const bool = !!this.value && typeof this.value === 'object' && this.value[0];
      if (!bool) this.el.value = null;
      else {
        this.dateFormat.date[0] = this.value[2]
        this.dateFormat.datetime12[0] = this.value[2]
        this.dateFormat.datetime24[0] = this.value[2]
      }
      return bool;
    },
    datenow() {
      const [_, format] = this.value
      const date = moment.utc().format(this.dateFormat[format][0]);
      return date;
    },
  },
};
</script>

<style>
.drag-item {
  border: 1px solid;
}
</style>
<style scoped >
::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: var(--current-outline);
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: var(--current-outline);
  opacity: 1;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: var(--current-outline);
  opacity: 1;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--current-outline);
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--current-outline);
}

::placeholder {
  /* Most modern browsers support this now. */
  color: var(--current-outline);
}
</style>
